import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getStpList, getSTPWeekBySTP, getTerritoryByEmpId, updateSTP, updateSTPWeek } from "./StpRepository";
import { showToast } from "../../../utils/toastUtils";


export const useStpListData = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["STP", params],
        queryFn: () => getStpList(params),
        enabled: enable,
        retry: false,
    });
};

export const useUpdateSTP = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }: { id: number; body: any }) =>
            updateSTP(id, body),
        onSuccess: (data) => {
            showToast.success("Update STP Successfully!");
            queryClient.invalidateQueries({ queryKey: ["STP"] });
        },
        onError: (error) => {
            console.error('error in update stp', error)
            showToast.warning("Failed to Update STP!");
        },
    });
};

export const useSTPWeeksBySTPData = ({
    params = {},
    id = null,
    enable = false,
}: { id?: number | any; params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["STP", params, id],
        queryFn: () => getSTPWeekBySTP(id, params),
        enabled: enable,
        retry: false,
    });
};
export const useUpdateSTPWeek = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }: { id: number; body: any }) =>
            updateSTPWeek(id, body),
        onSuccess: (data) => {
            showToast.success("Update STP Week Successfully!");
            queryClient.invalidateQueries({ queryKey: ["STP"] });
        },
        onError: (error) => {
            console.error('error in update stp week', error)
            showToast.warning("Failed to Update STP Week!");
        },
    });
};

export const useTerritoriesByEmpId = ({
    params = {},
    enable = false,
}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["STP", params],
        queryFn: () => getTerritoryByEmpId(params),
        enabled: enable,
        retry: false,
    });
};